import React, { useEffect, useState } from "react";
import { ArrowRightFromLine, BadgeCheck, Check, Delete, Eye, Pen, Settings } from "lucide-react";
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { getPushedForPurchase } from "../../../slices/company/tenderSlice";
import { API_URL } from "../../../utils/constant";
import PurchasePushedApprove from "./partials/purchased_push_approved";
import moment from "moment";
import axios from "axios";
import { customTableStyles } from "../../../utils/tableStylings";


const ApprovedPurchases = () => {
    const dispatch = useDispatch();
    const { push_purchase } = useSelector(state => state.tenders);
    const [modalShow, setModalShow] = useState(false);
    const [selectedPush, setSelectedPush] = useState([]);

    useEffect(() => {
        const company = JSON.parse(localStorage.getItem('company'));
        if (company) {
            const companyId = company.company?.id;
            dispatch(getPushedForPurchase({ id: companyId, status: "" }));
        }
    }, [dispatch]);


    const handleApprove = async (data) => {
        setSelectedPush(data);
        setModalShow(true);
    }

    const handleCheckApprove = async (data) => {
        const company = JSON.parse(localStorage.getItem('company'));
        const companyId = company.company?.id;
        const payload = {
            id: data.id,
            checked_by: companyId
        }
        try {
            const response = await axios.post(`${API_URL}/tenders/push/purchase/status/update`, payload);
            console.log("Purchase response:", response.data);
            Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: 'Pushed Approved',
                toast: true,          // Enable toast style
                position: 'top-end',  // Position at the top-right corner
                showConfirmButton: false,  // Hide the confirm button
                timer: 3000,          // Set the timer to auto-close after 3 seconds
                timerProgressBar: true,  // Show the progress bar for the timer
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer);
                    toast.addEventListener('mouseleave', Swal.resumeTimer);
                }
            });
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: 'Something Went Wrong!',
                toast: true,          // Enable toast style
                position: 'top-end',  // Position at the top-right corner
                showConfirmButton: false,  // Hide the confirm button
                timer: 3000,          // Set the timer to auto-close after 3 seconds
                timerProgressBar: true,  // Show the progress bar for the timer
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer);
                    toast.addEventListener('mouseleave', Swal.resumeTimer);
                }
            });
        }
    }



    const checkAnyPurchaseRequired = (purchases) => {
        return purchases.some(e => String(e.status) === "1");
    };


    const unitColumn = [
        {
            name: '#',
            cell: (row, index) => index + 1,
            width: '40px' // Keep fixed width for serial numbers
        },
        {
            name: 'Company',
            selector: row => row.customer?.company_name,
            sortable: true,
            wrap: true, // Allows text wrapping for auto width

        },
        {
            name: 'Contact Person',
            selector: row => (
                <div>
                    <strong>{row.customer?.name}</strong><br />
                    <small>({row.customer?.phone})</small>
                </div>
            ),
            sortable: true,
            wrap: true,
        },
        {
            name: 'Product Name',
            selector: row => row.finalProduct?.name,
            sortable: true,
            wrap: true,
        },
        {
            name: 'Quantity',
            selector: row => row.quantity,
            sortable: true,
            wrap: true,
            width: "120px",
        },
        {
            name: 'Sale Cost',
            selector: row => `₹ ${row.sale_cost}`,
            sortable: true,
            wrap: true,
            width: "120px",
        },
        {
            name: 'Date',
            selector: row => moment(row.date).format('YYYY-MM-DD'),
            sortable: true,
            wrap: true,
            width: "120px",
        },
        {
            name: 'Actions',
            cell: row => (
                <>
                    {checkAnyPurchaseRequired(row.pushedForPurchase) && row.pushedForPurchase?.length > 0 && row.status === 2 ? (
                        <>
                            <span
                                className="text-white btn btn-sm btn-success cursor-pointer me-1"
                                data-tooltip-id="tooltip"
                                data-tooltip-content="Check Details"
                                onClick={() => handleApprove(row)}
                            >
                                <Eye />
                            </span>
                            {row.pushedForPurchase[0].status === 0 && (<span
                                className="text-white btn btn-sm btn-primary cursor-pointer me-1"
                                data-tooltip-id="tooltip"
                                data-tooltip-content="Approve Purchase"
                                onClick={() => handleCheckApprove(row)}
                            >
                                <BadgeCheck />
                                {/* <ArrowRightFromLine /> */}
                            </span>)}
                        </>
                    ) : (
                        <span className="badge bg-success">Purchase Completed</span>
                    )}
                </>
            ),
            width: "220px", // Ensure enough space for buttons
        }

    ];



    return (
        <>
            <div className="card">
                <div className="card-header">
                    <div className="d-flex justify-content-between align-items-center">
                        <h3 className="text-primary mb-0">Approved Purchase</h3>
                    </div>
                </div>
                <div className="card-body">

                    <DataTable

                        columns={unitColumn}
                        data={push_purchase}
                        pagination
                        highlightOnHover
                        striped
                        dense
                        customStyles={customTableStyles}
                    />
                </div>
            </div>
            <PurchasePushedApprove show={modalShow} onClose={() => setModalShow(false)} heading={'Tender Details'} initialData={selectedPush} />
        </>
    );
}

export default ApprovedPurchases;
